import { Button, IconButton, Input, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Checkbox } from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import style from "./style";
import classNames from "classnames";
import { IconTrash, IconSearch } from "../../../../Icons";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import RowLoader from "../../../../../components/History/Grid/RowLoader";
import * as _ from "lodash";
import axios from "axios";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";  // Import the autoTable plugin
import { CircularProgress } from "../../../../Progress";


const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));

interface RowData {
    file_name: string;
    ad_format_name?: string;
    ad_placement_names?: string[];
    result?: string;
    children: RowData[];
    explanation: string;
    checked?: boolean;
    indexPath?:any;
}

interface Props {
    // Define your props here
    url: { flag: boolean, url: string }
    headerFields: any;
    readFrom: number;
    gridData: any[];
    loader: boolean;
    updatedData: any;
    exportPdf: any;
    deleteButton: any;
    isModalOpen: boolean;
    setMessage:any;
}


const ModalGrid = (props: Props): any => {
    const defaultExpand = true;  
    const { url, headerFields, readFrom, gridData, loader, updatedData, exportPdf, deleteButton, isModalOpen, setMessage } = props;
    const gridRef = useRef<any>(null);
    const [rowData, setRowData] = useState<any[]>([]);
    const [treeindex, setTreeindex] = useState<any>([]);
    const [records, setRecords] = useState<any>([]);
    const [showIndex, setShowIndex] = useState<any>(false);
    const [ExcelData, setExcelData] = useState<any>(null);
    const [sheet, setSheets] = useState<any>([]);
    const [headers, setHeaders] = useState<any>(headerFields);
    const [sheetrecords, setSheetrecords] = useState<any>([]);
    const [data, setData] = useState<any[]>([]);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);
    const [search, setSearch] = useState<string>("");
    let rowInx = 0; // Initialize rowInx to track rows across multiple hierarchies
    console.log(data,sheetrecords,headers,ExcelData,showIndex,rowData);
    const classes = useStyles();
    const [filters, setFilters] = useState<any>({
        page_number: 0,
        record_limit: 5,
        search: {
          text: "",
          typingTimeout: 0,
        },
      });

    useEffect(() => {
        // Simulate calling the child's method from the parent (after some event)
        if (!_.isEqual(exportPdf, "")){
            exportToPDF(exportPdf);
            setMessage("");
        }
    }, [exportPdf]);
    useEffect(()=>{
        //Set defaukt grid value empty
        setSelectedItems([]);
    },[isModalOpen]);

    useEffect(() => {
        if (url) {
            setRecords([]);
            setRowData([]);
            setData([]);
            setExcelData([]);
            setSheets([]);
            setSheetrecords([]);
            setTimeout(() => {
                fetchAndReadExcel(url.url);
            }, 200);
        } else {
            setRecords(gridData);
            setRowData(gridData);
            setData(gridData);
        }
    }, [url.flag]);
    useEffect(() => {
        setRecords(gridData);
        setRowData(gridData);
        setTimeout(() => {
            // Iterate over the root gridData and add children recursively
            gridData.forEach((item: any) => {
                if (item.children && _.gt(item.children.length, 0) && defaultExpand) {
                    addChildrenRecursively(item.children);
                }
                rowInx++;
            });

        }, 200);
    }, [gridData]);  // Dependency on gridData to trigger useEffect on data change
    useEffect(() => {
        if(_.gt(records.length, 0)) {
            let reversedData: any = [];
            // Reverse the data array before updating it
            if(_.gt(sheet.length, 0)) {
                reversedData = [...records].reverse();
            } else {
                reversedData = [...records];
            }
            updatedData(reversedData); // Pass the reversed data to updatedData
        }else{
            updatedData([]);
        }     
    }, [records]);

    const flattenTreeDataForPdf = (grdData: any, parent: any = null, level = 0):any => {
        return grdData
            .map((item: any) => {
                const flattenedItem = {
                    ...item,
                    parent: parent ? parent.fileName : null, // Track the parent fileName
                };
                // Recursively flatten the children and increase the level for deeper nodes
                const children = _.gt(item.children?.length, 0) ? flattenTreeDataForPdf(item.children, item, level + 1) : [];
                return [flattenedItem, ...children]; // Return the flattened item and its children
            }).flat(); // Flatten the nested arrays into one array
    };
    // Function to export grid data to PDF using jsPDF
    const cellWidth =():any=>{
        return  _.reduce(headerFields, (result:any, col:any, index:number) => {
              if (col.pdfColumnWidth) {
                  result[index] = { cellWidth: col.pdfColumnWidth };
              }
              return result;
          }, {});
      }; 

    const exportToPDF = (fileName: string):any => {
        try {
            if (_.gt(records.length,0)) {
                const doc = new jsPDF();
                // Column headers
                const pdfHeaders = _.map(headerFields,"headerName");
                const flatData = flattenTreeDataForPdf(records);
                const columnWidth = cellWidth();
                // Prepare data for PDF
                const pdfdata = flatData.map((node: any) => {
                    return headerFields.map((col: any) => node[col.field]);
                });
                // Add a table to the PDF
                autoTable(doc,{
                    head: [pdfHeaders],
                    body: pdfdata,
                    theme: "striped", // Add striped table rows
                    styles: {
                        overflow: "linebreak", // Handle text overflow in cells
                        cellWidth: "auto", // Let the table adjust the width of the cells
                    },
                    columnStyles:columnWidth,
                    didParseCell: function (ceilData: any) {
                        const foundItem = treeindex.find((cellItem: any) => _.isEqual(cellItem.index, ceilData.row.index));
                        if (foundItem) {
                            if (foundItem.level && _.isEqual(ceilData.column.index, 0) && !_.isEqual(foundItem.level, 0)) {
                                foundItem.level++;
                                ceilData.cell.styles.cellPadding = {
                                    left: foundItem.level * 3,   // Left padding
                                };
                            }
                        }
                    }
                });
                // Save the PDF
                doc.save(fileName + ".pdf");
            }
        } catch (e) {
            console.log("Error in pdf download ", e);
        }
    };

    // Function to refresh pagination and ensure the current page is correct
    const refreshPagination = ():any => {
        if (gridRef.current && gridRef.current.api) {
            // Force grid to update pagination after rows have been added
            gridRef.current.api.paginationGoToPage(gridRef.current.api.paginationGetCurrentPage());
        }
    };

    // Recursive function to add children at the correct index in the grid
    const addChildrenRecursively = (items: any[]):any => {
        items.forEach((item: any) => {
            addItemToGrid(item);
            // Only proceed if the item has children and the defaultExpand flag is true
            if (item.children && _.gt(item.children.length, 0) && defaultExpand) {
                addChildrenRecursively(item.children);
            }
        });
        refreshPagination();
    };
    const addItemToGrid = (item: any):any => {
        item.isNewRow = true;
        gridRef.current!.api.applyTransaction({
            add: [item],
            addIndex: rowInx + 1, // Adjust index for the correct position
        })!;
        if (item.childLevel) {
            const newItem = treeindex;
            newItem.push({ index: rowInx + 1, level: item.childLevel });
            // Update state by creating a new array with the new item
            setTreeindex(newItem);
        }
        rowInx++;
    };

    // const [gridData,setGridData] = useState(data);
    const handleToggleSelect = (checked:boolean,row: any,checkAll=false):any => {
        if(!checkAll){
            setRecords((prev:any)=>{
               return prev.map((obj:any)=>{
                   return obj.indexing === row.indexing ? {...obj,checked:checked} :obj;
                });  
            });
        }else{
            setRecords((prev:any)=>{
                return prev.map((obj:any):any=>{
                    return {...obj,checked:checked};
                 });  
             });
        }
    };
    const deleteSelect = ():void =>{
        setRecords((prev:any)=>{
           return  prev.filter((obj:any)=>{
            if(!obj.checked){
                return obj;
            }else{
                setSelectedItems((prevItem: any) => [...prevItem, obj]);
            }
           });
        });
        // 
    };
    

    const fetchAndReadExcel = async (downloadurl: string):Promise<any> => {
        try {
            if (downloadurl) {
                setShowIndex(true);
                const inputValue = downloadurl; // Access the input value
                // Step 1: Fetch the Excel file from the cloud bucket
                const response = await axios.get(inputValue,
                    { responseType: "arraybuffer" } // Important: Fetch as binary data
                );
                // Step 2: Convert the binary data to a workbook
                const workbook = XLSX.read(new Uint8Array(response.data), { type: "array" });
                if (!workbook || !workbook.SheetNames || _.isEqual(workbook.SheetNames.length, 0)) {
                    throw new Error("The uploaded file is not a valid Excel file or contains no sheets.");
                }
                // Set workbook and sheet names in state
                setExcelData(workbook);
                setSheets(workbook.SheetNames);
                // Get the first sheet name
                const firstSheetName = workbook.SheetNames[0];
                // Call SheetHeaders with the first sheet name and a starting row index
                const Sheet = workbook.Sheets[firstSheetName];
                const excel_headers = XLSX.utils.sheet_to_json(Sheet, {
                    header: 1,        // Get raw rows as arrays
                    range: readFrom - 1 // Start reading from the specific header row
                })[0]; // Take the first row after applying the range
                setHeaders(excel_headers);
            }
        } catch (error) {
            console.error("Error fetching or reading Excel file:", error);
        }
    };

    const filteredRecords = records.filter((row: any) => {
        if (!search) return true;
       
        const term = search.toLowerCase();
       
        return _.values(row).some((value) => {
          if (_.isArray(value)) {
            return value.some((v) =>
              _.toString(v).toLowerCase().includes(term)
            );
          }
       
          return _.toString(value).toLowerCase().includes(term);
        });
      });
   
    return (

        <div style={{ margin: "20px" }}> <div className="Filters" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {(_.isEqual(gridData.length, 0) && _.isEqual(records.length, 0)) && loader && <CircularProgress />}
            {deleteButton && <> <div className="Left">
                <div className={classes.search}>
                    <div
                        className={classes.searchIcon}
                        style={{ opacity: 1 }}
                    >
                        <IconSearch title={""} />
                    </div>
                    <Input
                        type="input"
                        id={"modalSearch"}
                        className={classNames(
                            classes.inputInput,
                            classes.inputElement
                        )}
                        value={search}
                        placeholder={"Search in table"}
                        onChange={(event: any) => {
                            const InputValue = event.target.value;
                            setSearch(InputValue);
                            setFilters((prevState: any) => ({
                                ...prevState,
                                page_number: 0,
                              }));
                        }}
                        inputProps={{
                            "aria-label": "search"
                        }}
                    />
                </div>
            </div>
                <div>
                    {!_.isUndefined(selectedItems) && !_.isUndefined(selectedItems?.length) &&
                        <Button
                            variant="text"
                            disabled
                        >{`${selectedItems?.length} record(s) removed`}</Button>}
                    <Button
                        className={classes.filterButton}
                        onClick={() => { deleteSelect();
                            setFilters((prevState: any) => ({
                                ...prevState,
                                page_number: 0,
                              }));
                         }}
                    >
                        <div style={{ opacity: 1 }}>
                            <IconTrash title={"Remove"}
                                onClick={() => { }}
                                isFileUpload={true}
                                fill="blue"
                                disabled={false} />
                        </div>
                        <div className={classes.filterText}>
                            {"Remove selected rows"}
                        </div>
                    </Button >
                </div>
            </>}


        </div>
            <TableContainer component={Paper} style={{ width: "980px", marginTop: "20px", marginBottom: "10px", maxHeight: "340px", overflow: "auto" ,boxShadow:"none"}}>
                <Table>
                    <TableHead style={{ height: "49px" }}>
                        <TableRow>
                            {headerFields.map((fieldinfo: any, index: number) => (
                                <TableCell key={fieldinfo.fieldinfo + index} style={{ textAlign: "left", paddingLeft: (index == 0 ? 0 : 2), paddingTop: "0px", paddingBottom: "0px" }}>
                                    {index == 0 && <> 
                                        <Checkbox
                                            onChange={(e) => handleToggleSelect(e.target.checked,{},true)}
                                            checked={_.every(records,{checked:true})}
                                            color="primary"
                                            checkedIcon={
                                                          <span className={classNames(classes.icon, classes.checkedIcon)} />
                                                        }
                                                        icon={<span className={classes.icon} />}
                                                        inputProps={{ "aria-label": "decorative checkbox" }}
                                            style={{opacity: loader ? 0 : 1}}
                                        />
                                    </>}
                                    {fieldinfo.headerName}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!_.isUndefined(records) && !loader && filteredRecords
                            .slice(filters.page_number * filters.record_limit, ((filters.page_number + 1) * filters.record_limit)).map((row: any, mainIndex: number) => (
                                <NestedRow key={row.id}  row={row} level={0} onToggleSelect={handleToggleSelect} 
                                mainIndex={mainIndex}  headerFields={headerFields} flagcheckbox = {true}
                            />
                        ))}
                       
                        {loader && <RowLoader cols={6} rows={10} />}
                    </TableBody>
                </Table>
            </TableContainer>
            {!loader && _.isEqual(records.length,0) && <div className={classes.norowsContent}>{"No Rows To Show"}</div>}

            <div className={classes.pagination}>
                {records.length > 0 && <TablePagination
                    component="div"
                    count={filteredRecords?.length}
                    labelRowsPerPage=""
                    rowsPerPage={filters.record_limit}
                    page={filters.page_number}
                    onPageChange={(offset, page) => {     
                        setFilters((prevState: any) => ({
                        ...prevState,
                        page_number: page,
                      })); }}
                />}
            </div>
        </div>
    );
};

const getHeaderName = (fileName: any,colourVaues:any): JSX.Element => {
    const FileName = _.isArray(fileName) ? _.join(fileName,",") : (fileName || "").toString().trim();
    const color = headerStyle(colourVaues,fileName);
    if (_.gt(FileName.length, 15)) {
        const Text = `${FileName.substring(0, 5)}...${FileName.substring(
            FileName.length - 10,
            FileName.length
        )}`;
        return (
            <Tooltip title={FileName} placement={"top"}>
                <span style={{color:color}}>{Text}</span>
            </Tooltip>
        );
    }
    return <span style={{color:color}}>{FileName}</span>;
};

const headerStyle = (colourVaues: any,valuerow:any):any => {
    if(_.isEmpty(colourVaues)){
        return "";
    }
    const value = colourVaues;
    const color = value[0] || "";
    return color[valuerow];
};

const NestedRow: React.FC<{ row: any; level: number, onToggleSelect: any, mainIndex: any, headerFields: any,flagcheckbox:boolean}> = ({ row, level, onToggleSelect, mainIndex, headerFields,flagcheckbox}) => {
    const [open, setOpen] = useState(false);
    const hasChildren = row.children && _.gt(row.children.length,0);
    const classes = useStyles();
    return (
        <>
            <TableRow className={classes.tableRow}>
                {headerFields.map((fieldinfo: any, index: number) => (
                    <>
                        <TableCell key={index} className={classes.tableColumn} style={{ paddingLeft: index == 0 && _.lt(level,1)  ? `${level * 30}px`  : (index==0 && _.gt(level,0) && hasChildren ? `${(level * 30)+28}px` : index==0 && _.gt(level,0) && !hasChildren ? `${(level * 30)+36}px`:0), width: `${fieldinfo.width}px`, paddingTop: "0px", paddingBottom: "0px" ,height:"49px"}}>
                            {_.isEqual(index,0) && <>
                                {flagcheckbox && <Checkbox
                                    onChange={(event: any)=>onToggleSelect(event.target.checked,row)}
                                    checked={_.isUndefined(row.checked)? false:row.checked}
                                    color="primary"
                                    checkedIcon={
                                                  <span className={classNames(classes.icon, classes.checkedIcon)} />
                                                }
                                                icon={<span className={classes.icon} />}
                                                inputProps={{ "aria-label": "decorative checkbox" }}
                                />}
                                {hasChildren && (
                                    <IconButton size="small" onClick={() => setOpen(!open)}>
                                             {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                    </IconButton>
                                )}
                            </>}
                            {fieldinfo.field !== "children" ? _.isEmpty(fieldinfo.width) ? getHeaderName(row[fieldinfo.field],fieldinfo.colourVaues) : (row[fieldinfo.field as keyof Omit<RowData, "children">] ?? "-") : ""}
                        </TableCell>
                    </>
                ))}
            </TableRow>
            {hasChildren && (
                <>
                    {open && <>
                        {row.children.map((child: any) => (
                            <NestedRow key={child.id} row={child} level={level + 1} flagcheckbox = {false}
                                onToggleSelect={onToggleSelect}  mainIndex={mainIndex}  headerFields={headerFields} />
                        ))}
                    </>}
                </>
            )}
        </>
    );
};

export default ModalGrid;

